import qs from "qs"

export const download_file = (file) => window.location = `${argus_url.ajax_raw}Download.php?${qs.stringify({ file })}`;
